// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1240":"css/admin-app.6804","5392":"css/app.6804"}[chunkId] + ".css";
};